import { Card, FormLayout, Frame, Layout, Loading, SkeletonBodyText, SkeletonPage } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import React from "react";

const GenerationSkeleton = () => {
  return (
    <Frame>
      <Loading />
      <SkeletonPage title={CsI18n.t("Generate")} fullWidth>
        <Layout>
          <Layout.AnnotatedSection title={CsI18n.t("generate.annotate.title.generate")}
                                   description={CsI18n.t('generate.annotate.desc.generate')}>
            <Layout.Section>
              <Card sectioned>
                <Card.Section>
                  <FormLayout>
                    <SkeletonBodyText lines={18} />
                  </FormLayout>
                </Card.Section>
              </Card>
            </Layout.Section>
          </Layout.AnnotatedSection>
        </Layout>
      </SkeletonPage>
    </Frame>
  );
};

export default GenerationSkeleton;
